var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75191 17.9183C5.87706 18.149 6.12475 18.2861 6.3867 18.2696L21.9438 17.2918C22.1825 17.2768 22.3953 17.1365 22.5032 16.9231C22.611 16.7097 22.5977 16.4551 22.4682 16.2541L17.4298 8.43187C17.2972 8.22587 17.0631 8.1081 16.8186 8.12429L2.05701 9.10207C1.82783 9.11725 1.62215 9.24809 1.51126 9.44923C1.40038 9.65037 1.39954 9.89414 1.50906 10.096L5.75191 17.9183Z",
    stroke: "#525D71",
    strokeWidth: 1.34811,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.1016L13.0892 11.7245",
    stroke: "#525D71",
    strokeWidth: 1.34811,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60156 14.2969L10.8962 14.1083",
    stroke: "#525D71",
    strokeWidth: 1.34811,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5255 2.51785C19.6214 2.34403 19.8401 2.28091 20.0139 2.37687L22.2735 3.62426C22.4473 3.72022 22.5104 3.93891 22.4145 4.11273L18.5704 11.076L15.7495 12.5876L15.6814 9.48113L19.5255 2.51785Z",
    fill: "white",
    stroke: "#525D71",
    strokeWidth: 1.34811,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6016 4.39844L21.6604 6.05476",
    stroke: "#525D71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDetails);
export default __webpack_public_path__ + "static/media/checkDetails.cf59ea988cb912ee04f30b665b177da7.svg";
export { ForwardRef as ReactComponent };